import 'stickybits/dist/jquery.stickybits.min.js'


jQuery(function($) {
  $(document).ready(function() {

    // more button

    $('.stories__more button').on('click', function(e) {
      e.stopPropagation();

      $(this).closest('.stories-section').addClass('all-stories');

      return false;
    })


    function createStickybitInstance(el) {
      var stickybitsInstance = $(el).stickybits({
        stickyBitStickyOffset: 140,
        // useFixed: true
      });
      $(el).data('stickybits', stickybitsInstance);
    }

    function updateStickybitInstance(el) {
      var stickybitsInstance = $(el).data('stickybits');
      if(stickybitsInstance) {
        stickybitsInstance.update();
      }
    }

    function cleanupStickybitInstance(el) {
      var stickybitsInstance = $(el).data('stickybits');
      if(stickybitsInstance) {
        stickybitsInstance.cleanup();
        $(el).data('stickybits', null);
      }
    }

    var stickyBitsActive = window.innerWidth >= 990;
    setTimeout(function() {
      $('.stories-primary').each(function() {
        if(stickyBitsActive) {
          createStickybitInstance(this);
        }
      })
    }, 200);

    var windowResizeTriggered = false;
    $(window).on('resize', function() {

      if(windowResizeTriggered) {
        stickyBitsActive = window.innerWidth >= 990

        $('.stories-primary').each(function() {
          var stickybitsInstance = $(this).data('stickybits')
          if(stickyBitsActive && stickybitsInstance) {
            updateStickybitInstance(this);
          } else if (stickyBitsActive) {
            createStickybitInstance(this);
          } else if (stickybitsInstance) {
            cleanupStickybitInstance(this);
          }
          $(this).width($(this).parent().width());
        });
        windowResizeTriggered = false;
        return ;
      } else {
        windowResizeTriggered = true;
        $('.stories-primary').each(function() {
          $(this).width(0);
        })
        $(window).trigger('resize');
      }
    })

  })
})
